import '.ac{z-index:2;}.ssr-plugin'
import '.ah{position:fixed;}.ssr-plugin'
import '.a{width:100%;}.ssr-plugin'
import '.ag{box-sizing:border-box;}.ssr-plugin'
import '.ai{padding:24px 16px;}.ssr-plugin'
import '.aj{max-width:1312px ;}.ssr-plugin'
import '.ak{margin:0 auto;}.ssr-plugin'
import '.f{flex:1;}.ssr-plugin'
import '.al{height:76px;}.ssr-plugin'
import '.o{display:flex;}.ssr-plugin'
import '.v{align-items:center;}.ssr-plugin'
import '.am{justify-content:space-between;}.ssr-plugin'
import '.an{border-radius:50px;}.ssr-plugin'
import '.ao{padding:0px 16px;}.ssr-plugin'
import '.ap{position:relative;}.ssr-plugin'
import '.aq{display:block;}.ssr-plugin'
import '.ar{pointer-events:none;}.ssr-plugin'
import '.as{gap:16px;}.ssr-plugin'
import '.at{margin-top:8px;}.ssr-plugin'
import '.a4{margin-right:8px;}.ssr-plugin'
import '.au{min-width:48px;}.ssr-plugin'
import '.av{font-size:14px;}.ssr-plugin'
import '.aw{text-align:center;}.ssr-plugin'
import { useRef, useState } from 'react'
import { useLocation } from 'wouter'
import { Logo } from '../assets/svg/Logo.js'
import { styled } from 'inlines'
import { Button } from './Button.js'
import { Icon } from '../assets/icons/index.js'
import { IconButton } from './IconButton.js'
import { Menu } from './Menu.js'
import { colors } from '../utils/colors.js'
import { Meter } from './Meter.js'
import { TABLET, MOBILE } from '../utils/breakpoints.js'
import { MenuVotingRegion } from './MenuVotingRegion.js'
import { SelectLanguageModal } from './SelectLanguageModal.js'
import { SelectVotingRegionModal } from './SelectVotingRegionModal.js'
import { useLanguage } from '../hooks/useLanguage.js'
import {
  useVotingRegion,
  useVotingRegionName,
} from '../hooks/useVotingRegion.js'
import { transparentColor } from '../utils/transparentcolor.js'
import { useDictionary } from '../hooks/useDictionary.js'

export const Navigation = ({ votes, hideCart }) => {
  const [, setLocation] = useLocation()

  const [votingRegion] = useVotingRegion()
  const { maxVotes = 10 } = votingRegion
  const total = Object.values<number>(votes ?? {}).reduce((a, b) => a + b, 0)

  const [lang] = useLanguage()
  const votingRegionName = useVotingRegionName(votingRegion?.code)

  const { cart, nOutOfMaxVotes } = useDictionary()

  const [openMenu, setOpenMenu] = useState(false)
  const [openLangMenu, setOpenLangMenu] = useState(false)
  const [openLangSelectModal, setOpenLangSelectModal] = useState(false)
  const [openRegionModal, setOpenRegionModal] = useState(false)

  const navRef = useRef<HTMLElement>(null)

  const getNavRight = () => {
    if (!navRef.current) return 0
    const rect = navRef.current.getBoundingClientRect()
    return window.innerWidth - rect.right
  }

  const getNavLeft = () => {
    if (!navRef.current) return 0
    const rect = navRef.current.getBoundingClientRect()
    return rect.left
  }

  return (
    <styled.div className="ac ah a ag ai"
      style={{
        background: `linear-gradient(180deg, ${transparentColor(colors.secondary, 1)} 0%, ${transparentColor(colors.secondary, 0)} 75%)`,
        [TABLET]: {
          padding: '16px 8px',
        },
      }}
    >
      <styled.nav className="blur aj ak f al o v am an ao ap"
        id="main-navbar-content"
        ref={navRef}
        style={{
          border: `1px solid ${colors.border}`,
          backgroundColor: transparentColor(colors.secondary, 0.3),
          [MOBILE]: {
            height: '64px',
            padding: '4px 12px',
          },
        }}
      >
        <Button
          ariaLabel="open-menu"
          id="main-navbar-action-menu-button"
          style={{
            [TABLET]: {
              width: 50,
              height: 50,
              minWidth: 50,
              minHeight: 50,
              padding: 0,
              justifyContent: 'center',
              aspectRatio: '1 / 1',
            },
          }}
          leadIcon={<Icon type="globeIcon" style={{ pointerEvents: 'none' }} />}
          trailIcon={
            <styled.span className="o v"
              style={{
                [TABLET]: { display: 'none' },
              }}
            >
              <Icon type={openLangMenu ? 'chevronUpIcon' : 'chevronDownIcon'} />
            </styled.span>
          }
          variant="ghost"
          onClick={() => setOpenLangMenu(!openLangMenu)}
        >
          <styled.span className="aq ar"
            style={{
              [TABLET]: { display: 'none' },
            }}
          >
            {votingRegionName} · {lang?.name}
          </styled.span>
        </Button>
        <Logo
          onClick={() => setLocation('/')}
          style={{
            position: 'absolute',
            left: '50%',
            transform: 'translateX(-50%) scale(1)',
            transformOrigin: 'center center',
            transition: 'transform 200ms ease',
            '&:hover': {
              transform: 'translateX(-50%) scale(0.98)',
            },
          }}
        />
        <div className="o v as">
          <styled.div className="at a4 au"
            style={{
              display: hideCart ? 'none' : 'block',
              [TABLET]: {
                display: 'none',
              },
            }}
          >
            <Meter
              value={(total / maxVotes) * 100}
              style={{ marginBottom: 8, width: '100%' }}
            />
            <p className="av aw"
              id="main-navbar-cart-count"
            >
              {nOutOfMaxVotes}
            </p>
          </styled.div>
          <Button
            ariaLabel={cart}
            id="main-navbar-action-open-cart-button"
            style={{
              display: hideCart ? 'none' : 'flex',
              [TABLET]: { display: 'none' },
            }}
            trailIcon={<Icon type="forwardIcon" color={colors.secondary} />}
            onClick={() => setLocation('/cart')}
          >
            {cart}
          </Button>
          <IconButton
            size="large"
            ariaLabel="toggle-menu"
            onClick={() => {
              setOpenMenu(!openMenu)
            }}
            variant="ghost"
            id="main-navbar-action-open-navigation-menu-button"
            icon={
              openMenu ? (
                <Icon type="closeIcon" style={{ pointerEvents: 'none' }} />
              ) : (
                <Icon type="menuIcon" />
              )
            }
          />
        </div>
      </styled.nav>

      {openMenu && (
        <Menu
          setOpenMenu={setOpenMenu}
          totalVotes={total}
          hideCart={hideCart}
          style={{
            left: lang.rtl ? getNavLeft() : null,
            right: lang.rtl ? null : getNavRight(),
            [TABLET]: {
              top: '104px',
              right: '8px',
            },
            [MOBILE]: {
              left: '8px',
              right: '8px',
              width: 'auto',
              top: '98px',
            },
          }}
        />
      )}

      {openLangMenu && (
        <MenuVotingRegion
          id="menu-lang-region"
          triggerId="main-navbar-action-menu-button"
          setOpen={setOpenLangMenu}
          setOpenLangSelectModal={setOpenLangSelectModal}
          setOpenRegionModal={setOpenRegionModal}
          style={{
            left: lang.rtl ? null : getNavLeft(),
            right: lang.rtl ? getNavRight() : null,
            [TABLET]: {
              top: '104px',
              left: '8px',
            },
            [MOBILE]: {
              left: '8px',
              right: '8px',
              width: 'auto',
              top: '98px',
            },
          }}
        />
      )}

      {openLangSelectModal && (
        <SelectLanguageModal setModal={setOpenLangSelectModal} />
      )}

      {openRegionModal && (
        <SelectVotingRegionModal setModal={setOpenRegionModal} />
      )}
    </styled.div>
  )
}
